document.addEventListener("DOMContentLoaded", () => {
  const style = document.createElement("style");
  style.textContent = ".additional-de { display: none; }";
  document.head.appendChild(style);

  fetch("/browsing_context_suggestions.json")
    .then((response) => response.json())
    .then((data) => {
      const country = data?.detected_values?.country?.handle;

      if (country !== "DE") return;

      const visibleStyle = document.createElement("style");
      visibleStyle.textContent = ".additional-de { display: revert !important; }";
      document.head.appendChild(visibleStyle);
    })
    .catch((err) => {
      console.error("Browsing context fetch error:", err);
    });
});
